import { render, staticRenderFns } from "./readOnlyManual.vue?vue&type=template&id=63dbc370&scoped=true"
import script from "./readOnlyManual.vue?vue&type=script&lang=js"
export * from "./readOnlyManual.vue?vue&type=script&lang=js"
import style0 from "./readOnlyManual.vue?vue&type=style&index=0&id=63dbc370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dbc370",
  null
  
)

export default component.exports